import React, { useState } from 'react';
import styles from './EstimatorView.module.scss';
import {
  Disclaimer,
  LoadingSpinner,
  BusinessAreaSelection,
  ServiceSelection,
  InputSection,
  EstimatedCost,
  EstimateButton
} from 'app/components';
import {
  getBusinessArea,
  useAppSelector,
  getService,
  getCurrentFile,
  getInputSize,
  setIsEstimatedCostModal,
  useAppDispatch
} from 'app/redux';
import { getProduct } from 'integration';
import { IProductsResponse } from './EstimatorView.interface';

export const EstimatorView: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalCost, setTotalCost] = useState<number>(0);
  const [currency, setCurrency] = useState<string>('');

  const currentBusinessArea = useAppSelector(getBusinessArea);
  const currentService = useAppSelector(getService);
  const currentFile = useAppSelector(getCurrentFile);
  const inputSize: number | undefined = useAppSelector(getInputSize);

  const dispatch = useAppDispatch();

  const fetchProductInfo = (): void => {
    if (currentService) {
      setIsLoading(true);
      getProduct(String(currentService))
        .then((response) => {
          calculateTotalCost(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const calculateTotalCost = (response: IProductsResponse): void => {
    setCurrency(response.currency ?? '');
    if (inputSize) {
      let cost;
      if (response.unit === 'input_size_in_mb') {
        cost = inputSize * response.price;
      } else {
        cost = response.price;
      }
      setTotalCost(cost);
    }
  };

  const handleCalculateClick = (): void => {
    fetchProductInfo();
    dispatch(setIsEstimatedCostModal(true));
  };

  return (
    <div className={styles['cost-calculator']}>
      <div className={styles.intro}>
        <h3>Let&apos;s calculate it!</h3>
        <p>Upload a file and we can tell you how much it cost you!</p>
      </div>
      <div className={styles.wrapper}>
        <BusinessAreaSelection />
        <ServiceSelection />
        <InputSection />
        <EstimateButton onClick={handleCalculateClick} />
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <EstimatedCost
          businessArea={currentBusinessArea}
          service={currentService}
          file={currentFile}
          totalCost={totalCost}
          currency={currency}
        />
      )}

      <Disclaimer />
    </div>
  );
};
